import { funcState } from '../../utils/funcState';
import { Filters } from '../utils/filtersEnum';
import { getLocationStateFromCategoryData } from '../../../views/CategoryPage/provider/location';

const LocationFilterProvider = ({ updateFilter }) => {
  const [viewport, setViewport] = funcState();
  const [point, setPoint] = funcState();
  const [name, setName] = funcState();
  const [isLocationSetByUser, setIsLocationSetByUser] = funcState();

  const cleanViewport = (propViewport) => ({
    ne: {
      lat: parseFloat(propViewport?.ne?.lat),
      lng: parseFloat(propViewport?.ne?.lng),
    },
    sw: {
      lat: parseFloat(propViewport?.sw?.lat),
      lng: parseFloat(propViewport?.sw?.lng),
    },
  });

  const cleanPoint = (propPoint) => ({
    lat: parseFloat(propPoint?.lat),
    lng: parseFloat(propPoint?.lng),
    radius: parseInt(propPoint?.radius, 10),
  });

  const update = ({ categoryData, queryParams }) => {
    const {
      location: { viewport: propViewport, point: propPoint, name: propName },
      isLocationSetByUser: propIsLocationSetByUser,
    } = getLocationStateFromCategoryData(categoryData, queryParams);

    setViewport(propViewport ? cleanViewport(propViewport) : null);
    setPoint(propPoint ? cleanPoint(propPoint) : null);
    setName(propName);
    setIsLocationSetByUser(propIsLocationSetByUser);

    updateFilter({
      key: Filters.Location,
      value: {
        viewport: viewport.value,
        point: point.value,
        name: name.value,
        isLocationSetByUser: isLocationSetByUser.value,
      },
    });
  };

  const setLocation = ({
    type,
    viewport: propViewport,
    point: propPoint,
    name: propName,
  }) => {
    if (type === 'Viewport') {
      setPoint(undefined);
      setViewport(cleanViewport(propViewport));
    }

    if (type === 'Point') {
      setPoint(cleanPoint(propPoint));
      setViewport(undefined);
    }

    if (propName) {
      setName(propName);
    }

    setIsLocationSetByUser(true);

    updateFilter({
      key: Filters.Location,
      value: {
        viewport: viewport.value,
        point: point.value,
        name: name.value,
        isLocationSetByUser: isLocationSetByUser.value,
      },
    });
  };

  const toQueryParams = () => {
    return {
      viewportNorthEastLat: viewport.value?.ne?.lat,
      viewportNorthEastLong: viewport.value?.ne?.lng,
      viewportSouthWestLat: viewport.value?.sw?.lat,
      viewportSouthWestLong: viewport.value?.sw?.lng,
      locationLat: point.value?.lat,
      locationLong: point.value?.lng,
      locationSearchRadius: point.value?.radius,
      selectedLocationName: name.value,
      locationName: name.value,
    };
  };

  const defaultFilters = {
    viewportNorthEastLat: undefined,
    viewportNorthEastLong: undefined,
    viewportSouthWestLat: undefined,
    viewportSouthWestLong: undefined,
    locationLat: undefined,
    locationLong: undefined,
    locationSearchRadius: undefined,
    selectedLocationName: undefined,
    locationName: undefined,
  };

  const hasActiveFilters = () => {
    return !!isLocationSetByUser;
  };

  return {
    exposed: { setLocation },
    update,
    toQueryParams,
    hasActiveFilters,
    defaultFilters,
  };
};

export default LocationFilterProvider;
